import * as React from 'react';
import {DemoContainer} from '@mui/x-date-pickers/internals/demo';
import {AdapterDateFnsJalali} from '@mui/x-date-pickers/AdapterDateFnsJalali';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import DatePickerIcon from '@icons/DatePickerIcon';

interface IProps {
	value: Date | null;
	className?: string;
	onChange: (value: Date | null) => void;
}

export default function DatePickerRez({value, className, onChange}: IProps) {
	
	return (
		<LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
			<DemoContainer components={['DatePicker']}>
				<DatePicker
					slots={{
						openPickerIcon: DatePickerIcon
						
					}}
					sx={{bgcolor: 'grey.50', borderColor: 'grey.100'}}
					className={className}
					value={value}
					onChange={(newValue) => onChange(newValue)}/>
			</DemoContainer>
		</LocalizationProvider>
	);
}
